/* ============
 * ExciseEntry Transformer
 * ============
 */

import Transformer from './transformer';
import moment from 'moment';

export default class ExciseEntryTransformer extends Transformer {

  static fetch(entry) {
    return {
      id: entry.id,
      flag: entry.flag,
      createdAt: moment(entry.created_at).format('DD-MM-YY'),
      excisableType: entry.excisable_type,
      productName: entry.product,
      qty: entry.qty,
      volume: entry.volume,
      abv: entry.abv,
      amountLiter: entry.amount_liter,
      exciseType: entry.excise_type,
      exciseGroup: entry.excise_group,
      exciseBasic: entry.excise_basic,
      excisePackaging: entry.excise_packaging,
      exciseAdditionalCode: entry.additional_code,
      additionalCodeDesc: entry.additional_code_desc,
      excisableId: entry.excisable_id,
      excisable: entry.excisable,
      linkId: entry.link_id,
      receiverName: entry.receiver_name,
    };
  }

  static send(entry) {
    return {
      id: entry.id,
      excise_group_id: entry.exciseGroup,
      excise_basic_id: entry.exciseBasic,
      excise_packaging_id: entry.excisePackaging,
      excise_additional_code_id: entry.exciseAdditionalCode,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/exciseEntry.js